"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _clientjs = _interopRequireDefault(require("clientjs"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = getDebugInfo;

function getDebugInfo() {
  var a = new _clientjs["default"](),
      b = {
    userAgent: a.getUA()
  };
  return JSON.stringify(b);
}